module.exports = __webpack_public_path__ + "img/sms_hover.d8ecd442.svg";